(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var form = document.querySelector('.cart-page__form');
    if (!form) return;

    var qtyInputs = form.querySelectorAll('.cart-page__qty');
    if (!qtyInputs.length) return;

    var submitTimer = null;
    var isSubmitting = false;

    function submitCartUpdate() {
      if (isSubmitting) return;
      isSubmitting = true;
      form.submit();
    }

    function queueSubmit() {
      if (submitTimer) clearTimeout(submitTimer);
      submitTimer = setTimeout(submitCartUpdate, 250);
    }

    qtyInputs.forEach(function (input) {
      input.addEventListener('change', queueSubmit);
      input.addEventListener('blur', queueSubmit);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          queueSubmit();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["digital-photobooth"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const CONFIG = {
      frameCount: 4,
      countdownSeconds: 3,
      captureDelay: 1500
    };

    const stages = {
      countdown: document.querySelector('[data-stage="countdown"]'),
      capture: document.querySelector('[data-stage="capture"]'),
      result: document.querySelector('[data-stage="result"]')
    };
    const preview = document.querySelector('[data-preview]');
    const canvas = document.querySelector('[data-canvas]');
    const stripCanvas = document.querySelector('[data-strip-canvas]');
    const countdownEl = document.querySelector('[data-countdown]');
    const countdownNum = document.querySelector('[data-countdown-num]');
    const poseHint = document.querySelector('[data-pose-hint]');
    const startBtn = document.querySelector('[data-start]');
    const retryBtn = document.querySelector('[data-retry]');
    const downloadPng = document.querySelector('[data-download-png]');
    const downloadGif = document.querySelector('[data-download-gif]');

    let stream = null;
    let frames = [];
    let poseMessages = [];

    function showStage(name) {
      Object.keys(stages).forEach(function(k) {
        if (stages[k]) {
          stages[k].hidden = k !== name;
        }
      });
    }

    function showCountdown() {
      showStage('countdown');
      let n = CONFIG.countdownSeconds;
      countdownNum.textContent = n;
      const interval = setInterval(function() {
        n--;
        if (n > 0) {
          countdownNum.textContent = n;
        } else {
          clearInterval(interval);
          startCapture();
        }
      }, 1000);
    }

    function startCapture() {
      showStage('capture');
      let frameIndex = 0;
      frames = [];

      function captureFrame() {
        if (frameIndex >= CONFIG.frameCount) {
          finishCapture();
          return;
        }
        poseHint.textContent = poseMessages[frameIndex] || 'Pose ' + (frameIndex + 1) + '!';
        const ctx = canvas.getContext('2d');
        canvas.width = preview.videoWidth;
        canvas.height = preview.videoHeight;
        ctx.save();
        ctx.scale(-1, 1);
        ctx.drawImage(preview, -canvas.width, 0, canvas.width, canvas.height);
        ctx.restore();
        frames.push(canvas.toDataURL('image/png'));
        frameIndex++;
        setTimeout(captureFrame, CONFIG.captureDelay);
      }
      setTimeout(captureFrame, 500);
    }

    function finishCapture() {
      if (stream) {
        stream.getTracks().forEach(function(t) { t.stop(); });
      }
      renderStrip();
      showStage('result');
      startBtn.hidden = true;
      if (retryBtn) retryBtn.hidden = false;
    }

    function renderStrip() {
      const count = frames.length;
      const w = 300;
      const h = Math.round((w * 4) / 3);
      const stripW = w * count;
      const stripH = h;
      stripCanvas.width = stripW;
      stripCanvas.height = stripH;
      const ctx = stripCanvas.getContext('2d');
      let loaded = 0;
      function tryDraw() {
        loaded++;
        if (loaded >= count) {
          downloadPng.href = stripCanvas.toDataURL('image/png');
        }
      }
      for (let i = 0; i < count; i++) {
        const img = new Image();
        img.onload = (function(idx) {
          return function() {
            ctx.drawImage(img, idx * w, 0, w, stripH);
            tryDraw();
          };
        })(i);
        img.src = frames[i];
      }
    }

    function initPoseMessages() {
      const msgs = document.querySelectorAll('[data-pose-msg]');
      poseMessages = Array.from(msgs).map(function(el) { return el.textContent; });
      if (poseMessages.length === 0) {
        poseMessages = ['Pose 1!', 'Pose 2!', 'Pose 3!', 'Pose 4!'];
      }
    }

    startBtn.addEventListener('click', function() {
      initPoseMessages();
      navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: 640, height: 480 } })
        .then(function(s) {
          stream = s;
          preview.srcObject = s;
          showCountdown();
        })
        .catch(function() {
          alert('Camera access is required. Please allow camera permissions.');
        });
    });

    if (retryBtn) {
      retryBtn.addEventListener('click', function() {
        showStage('countdown');
        startBtn.hidden = false;
        retryBtn.hidden = true;
        frames = [];
      });
    }

    if (downloadGif) {
      downloadGif.addEventListener('click', function(e) {
        e.preventDefault();
        alert('GIF generation requires a library. For now, use the PNG download. You can add gif.js or similar for full GIF support.');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var btn = document.querySelector('.header__menu-btn');
    var drawer = document.getElementById('header-menu');
    if (!btn || !drawer) return;
    function closeMenu() {
      btn.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    function openMenu() {
      btn.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    btn.addEventListener('click', function() {
      if (btn.getAttribute('aria-expanded') === 'true') closeMenu();
      else openMenu();
    });
    drawer.querySelectorAll('.header__drawer-link').forEach(function(link) {
      link.addEventListener('click', closeMenu);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const wrap = document.querySelector('.hero-banner__video-wrap');
    if (!wrap) return;
    const video = wrap.querySelector('[data-video-control]');
    const toggle = wrap.querySelector('[data-video-toggle]');
    if (!video || !toggle) return;

    toggle.addEventListener('click', function() {
      const paused = video.paused;
      if (paused) {
        video.play();
        toggle.setAttribute('data-paused', 'false');
        toggle.setAttribute('aria-label', '{{ "sections.hero_banner.video_pause" | t }}');
      } else {
        video.pause();
        toggle.setAttribute('data-paused', 'true');
        toggle.setAttribute('aria-label', '{{ "sections.hero_banner.video_play" | t }}');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["memory-locations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initLocations() {
      var section = document.querySelector('.memory-locations[data-scroll-animate]');
      if (!section) return;

      function showSection() {
        section.classList.add('is-visible');
      }

      var rect = section.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        showSection();
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) showSection();
        });
      }, { threshold: 0, rootMargin: '50px 0px' });
      observer.observe(section);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLocations);
    } else {
      initLocations();
    }

    document.querySelectorAll('.memory-locations__card').forEach(function(card) {
      var slides = card.querySelectorAll('.memory-locations__slide');
      var dots = card.querySelectorAll('.memory-locations__dot');
      if (slides.length <= 1) return;

      var current = 0;
      var interval;

      function goToSlide(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function(s, i) {
          s.classList.toggle('memory-locations__slide--active', i === current);
        });
        dots.forEach(function(d, i) {
          d.classList.toggle('memory-locations__dot--active', i === current);
        });
      }

      function next() {
        goToSlide(current + 1);
      }

      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          goToSlide(i);
          clearInterval(interval);
          interval = setInterval(next, 8000);
        });
      });

      interval = setInterval(next, 8000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photobooth-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const loading = document.getElementById('photobooth-loading');
    const hero = document.getElementById('photobooth-hero');

    function initScrollTransition() {
      if (!hero) return;
      const booth = hero.querySelector('.photobooth-hero__booth');
      let ticking = false;
      function onScroll() {
        if (!ticking) {
          requestAnimationFrame(function() {
            const rect = hero.getBoundingClientRect();
            const progress = Math.min(1, Math.max(0, -rect.top / (rect.height * 0.5)));
            const scale = 1 - progress * 0.15;
            const opacity = 1 - progress * 0.3;
            if (booth) {
              booth.style.transform = 'scale(' + scale + ')';
              booth.style.opacity = opacity;
            }
            ticking = false;
          });
          ticking = true;
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    initScrollTransition();

    function initLoading() {
      if (!loading) return;
      const hasSeen = sessionStorage.getItem('memory-shop-seen');
      if (hasSeen) {
        loading.style.display = 'none';
        return;
      }
      loading.setAttribute('aria-hidden', 'false');
      setTimeout(function() {
        loading.setAttribute('aria-hidden', 'true');
        sessionStorage.setItem('memory-shop-seen', '1');
      }, 1500);
    }
    initLoading();

    const menuBtn = document.querySelector('[data-mobile-menu-toggle]');
    const navList = document.querySelector('[data-nav-list]');
    if (menuBtn && navList) {
      menuBtn.addEventListener('click', function() {
        const expanded = menuBtn.getAttribute('aria-expanded') === 'true';
        menuBtn.setAttribute('aria-expanded', !expanded);
        navList.setAttribute('data-expanded', !expanded);
      });
    }

    const videoToggle = document.querySelector('[data-video-toggle]');
    const video = document.querySelector('[data-video-control]');
    if (videoToggle && video) {
      videoToggle.addEventListener('click', function() {
        const paused = video.paused;
        if (paused) {
          video.play();
          videoToggle.setAttribute('data-paused', 'false');
          videoToggle.setAttribute('aria-label', document.querySelector('[data-i18n-video-pause]')?.textContent || 'Pause video');
        } else {
          video.pause();
          videoToggle.setAttribute('data-paused', 'true');
          videoToggle.setAttribute('aria-label', document.querySelector('[data-i18n-video-play]')?.textContent || 'Play video');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
